var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-article-view"},[_c('van-list',{attrs:{"finished":_vm.finished},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},_vm._l((_vm.list),function(item){return _c('ArticleItemView',{key:item.Id,attrs:{"item":item},on:{"click":_vm.toArticleContent}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }